import { SystemGuidePage } from './SystemGuidePage';

export function SystemPage() {
  return <SystemGuidePage />;
}

